import { Outlet } from 'react-router-dom';
import AppHeader from './layout/AppHeader.jsx';

export default function DmsShell() {
  return (
    <div className="hr-shell">
      <AppHeader />
      <main className="hr-main full" style={{ padding: 0 }}>
        <Outlet />
      </main>
    </div>
  );
}
